module.exports = __webpack_public_path__ + "static/img/img3.f54cc6c9.png";